import { createSelector } from 'selectors'

import { constants } from './tooltip-select.constant'

export const getTarget = (scope?: HTMLElement) =>
	createSelector<HTMLSelectElement>({ scope, selector: constants.selector.target })

export const getSaveDataField = () => createSelector<HTMLElement>({ selector: constants.selector.saveData })
